import React, { Component } from 'react';
import StatusIcon from '../../../assets/dashboardIcons/StatusIcon.png';

class DisabledMenu extends Component {
  onPanelClick = () => {
    const { enqueueSnackbar } = this.props;
    enqueueSnackbar('Please submit previous section first', { variant: 'error' });
  };
  render() {
    const { subMenu } = this.props;
    return (
      <React.Fragment>
        <div className="disabled-menu-item" onClick={this.onPanelClick}>
          <div className="label-name">
            <div className="status-img">
              <img src={StatusIcon} />
            </div>

            <div className="d-grid">
              <span>{subMenu.menuName}</span>
              <span>Incomplete</span>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DisabledMenu;
